module.exports = __webpack_public_path__ + "img/phone_switch.505f89c0.png";